<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="581" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Sửa thông tin ra vào
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <CheckinConfirmDialog :state="confirmDialog" :type="type" @confirm="save" />
        <v-form ref="form" class="pt-4">
          <v-row>
            <v-col> Ngày {{getCurrentDate}}</v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <CardTeacherName :teacher="selectedTeacherAttendance.teacher" />
            </v-col>
            <v-col cols="6" class="d-flex justify-space-between align-center">
              <div>
                <p class="text-caption my-0">Ngày sinh</p>
                <span>{{ $_get(selectedTeacherAttendance, 'teacher.dob', '') | ddmmyyyy }}</span>
              </div>
              <div>
                <p class="text-caption my-0">Loại cán bộ</p>
                <span>{{$_get(selectedTeacherAttendance, 'teacher.type', '') | getTeacherType}}</span>
              </div>
              <div>
                <p class="text-caption my-0">Lĩnh vực</p>
                <span>{{$_get(selectedTeacherAttendance, 'subjectGroup.title', '')}}</span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="d-flex align-center"> Giờ đến (24h) <span class="error--text">*</span> </v-col>
            <v-col cols="8" class="d-flex align-center">
              <TimeInput
                label="Giờ đến (24h)"
                outlined
                dense
                outline
                :date.sync="checkIn"
                :selectedDate="getCurrentDate"
                class="required"
                :rules="[$rules.required, $rules.time]"
                :disabled="isCheckInDisabled"
                validate-on-blur
              />
              <div v-if="oldIn">
                <v-icon right v-if="isCheckInDisabled" @click="openEditConfirm('in')">mdi-pencil</v-icon>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="d-flex align-center">Giờ về (24h) </v-col>
            <v-col cols="8" class="d-flex align-center">
              <TimeInput
                label="Giờ về (24h)"
                outlined
                dense
                outline
                :selectedDate="getCurrentDate"
                :rules="[$rules.time]"
                :date.sync="checkOut"
                :disabled="isCheckOutDisabled"
                validate-on-blur
              />
              <div v-if="oldIn">
                <v-icon right v-if="isCheckOutDisabled" @click="openEditConfirm('out')"> mdi-pencil </v-icon>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" dark depressed color="#0D47A1" outlined @click="cancel">Đóng</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="openDialog">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TimeInput from '@/components/basic/TimeInput.vue'
import CardTeacherName from '../../../components/basic/card/CardTeacherName.vue'
import CheckinConfirmDialog from './CheckinConfirmDialog.vue'
import moment from 'moment'
import { mapActions } from 'vuex'
import { get } from 'lodash'

export default {
  components: {
    TimeInput,
    CardTeacherName,
    CheckinConfirmDialog
  },
  props: {
    selectedTeacherAttendance: Object,
    selectedTeacherCheckin: Object,
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      checkIn: '',
      checkOut: '',
      oldIn: '',
      oldOut: '',
      editType: '',
      type: '',
      confirmDialog: false,
      isCheckOutDisabled: false,
      isCheckInDisabled: false,
    }
  },
  computed: {
    getCurrentDate() {
      return moment(this.selectedTeacherAttendance.time).format('DD/MM/YYYY')
    }
  },
  methods: {
    ...mapActions('teacherAttendance', ['createTeacherCheckinAdmin', 'updateTeacherAttendance', 'updateTeacherCheckinAdmin']),
    cancel() {
      this.dialog = false
    },
    openEditConfirm(type) {
      this.$dialog.confirm({
        title: 'Xác nhận sửa',
        text: 'Thao tác này sẽ chỉnh sửa thời gian điểm danh của học sinh. Xác nhận sửa?',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: () => {
          this.editType = type
          this.edit(type)
        }
      })
    },
    edit(type) {
      if (type === 'in') {
        this.isCheckInDisabled = false
      } else {
        this.isCheckOutDisabled = false
      }
    },
    async save(data) {
      if (!this.$refs.form.validate()) return
      if (this.checkIn && this.checkOut && moment(this.checkIn).isAfter(moment(this.checkOut))) {
        this.$alert.error('Giờ về phải lớn hơn giờ đến')
        return
      }
      try {
        this.$loading.active = true
        if (!get(this.selectedTeacherCheckin, 'id', '')) {
          await this.createTeacherCheckinAdmin({
            status: this.checkOut ? 'left' : 'attendance',
            checkIn: this.checkIn,
            checkOut: this.checkOut || null,
            teacherAttendance: this.selectedTeacherAttendance.id,
            teacher: get(this.selectedTeacherAttendance, 'teacher.id', ''),
          })

          await this.updateTeacherAttendance({
            id: this.selectedTeacherAttendance.id,
            status: this.checkOut ? 'left' : 'attendance',
            time: this.checkOut ? this.checkOut : this.checkIn
          })
          this.$alert.updateSuccess()
          this.dialog = false
        } else {
          if (this.selectedTeacherCheckin.checkOut && !this.checkOut) {
            this.$alert.error('Giáo viên này đã rời trường vui lòng nhập thời gian ra về')
            return
          }
          await this.updateTeacherCheckinAdmin({
            id: this.selectedTeacherCheckin.id,
            status: this.checkOut ? 'left' : 'attendance',
            type: data.type,
            checkIn: this.checkIn,
            checkOut: this.checkOut,
          })
          await this.updateTeacherAttendance({
            id: this.selectedTeacherAttendance.id,
            status: this.checkOut ? 'left' : 'attendance',
            time: this.checkOut ? this.checkOut : this.checkIn
          })
          this.$alert.updateSuccess()
          this.dialog = false
        }
        this.dialog = false
      } catch (error) {
        this.$alert.updateError()
      } finally {
        this.$loading.active = false
      }
    },
    openDialog() {
      const isCheckin = this.checkIn !== this.oldIn
      const isCheckOut = this.checkOut !== this.oldOut
      const type = isCheckin && isCheckOut ? 'both' : isCheckin ? 'in' : isCheckOut ? 'out' : ''
      this.type = type
      this.confirmDialog = !this.confirmDialog
    }
  },
  watch: {
    state() {
      this.dialog = true
      if (this.selectedTeacherCheckin && this.selectedTeacherCheckin.id) {
        this.checkIn = this.selectedTeacherCheckin.checkIn ? moment(this.selectedTeacherCheckin.checkIn).toISOString() : '',
        this.checkOut = this.selectedTeacherCheckin.checkOut ? moment(this.selectedTeacherCheckin.checkOut).toISOString() : '',
        this.oldIn = this.selectedTeacherCheckin.checkIn ? moment(this.selectedTeacherCheckin.checkIn).toISOString() : '',
        this.oldOut = this.selectedTeacherCheckin.checkOut ? moment(this.selectedTeacherCheckin.checkOut).toISOString() : '',
        this.isCheckInDisabled = !!this.checkIn,
        this.isCheckOutDisabled = !!this.checkOut
      } else {
        this.checkIn = '',
        this.checkOut = '',
        this.oldIn = '',
        this.oldOut = '',
        this.isCheckInDisabled = false,
        this.isCheckOutDisabled = false
      }
    }
  }
}
</script>
